import { normalizeDisplayLanguage } from '../utils/locale';

// Accessibility reads named units rather than interpreting the visual 2:05 as
// a clock time. This presentation helper never changes billed seconds.
export function formatCallHistoryDuration(seconds: number, language: string): string {
  const wholeSeconds = Number.isFinite(seconds) ? Math.max(0, Math.floor(seconds)) : 0;
  const minutes = Math.floor(wholeSeconds / 60);
  const remainingSeconds = wholeSeconds % 60;
  const locale = normalizeDisplayLanguage(language);
  const formatUnit = (value: number, unit: 'minute' | 'second') => new Intl.NumberFormat(locale, {
    style: 'unit',
    unit,
    unitDisplay: 'long',
    maximumFractionDigits: 0,
  }).format(value);

  if (minutes === 0) return formatUnit(remainingSeconds, 'second');
  if (remainingSeconds === 0) return formatUnit(minutes, 'minute');
  return `${formatUnit(minutes, 'minute')} ${formatUnit(remainingSeconds, 'second')}`;
}
